import { fetchPackDetail, openDeleteModal, openDocumentInfoModal, openUnlockModal, setCurrentRecord } from "../../../redux/JobModule/InProgressPage/InProgressAction";
import { getDownloadPackdetails, openDownloadModal } from "../../../redux/Transcribe/TranscribeAction";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import DeleteButton from "../../SharedComponent/ActionButtons/DeleteButton";
import DownloadButton from "../../SharedComponent/ActionButtons/DownloadButton";
import EditButton from "../../SharedComponent/ActionButtons/EditButton";
import InfoButton from "../../SharedComponent/ActionButtons/InfoButton";
import LockButton from "../../SharedComponent/ActionButtons/LockButton";
import PlayButtton from "../../SharedComponent/ActionButtons/PlayButtton";
interface InProgressActionColumnProps {
  record: any;
}

function InProgressActionColumn({ record }: InProgressActionColumnProps) {
  const dispatch = useAppDispatch();
  return (
    <div className="d-flex gap-2 w-100 justify-content-center">
      {(record.status === "IN_PROGRESS" || record.status === "QC_READY" || record.status === "FAILED" || record.status === "QC_IN_PROGRESS") &&
        (record.isExportResultAvailable === 1 ? (
          <DownloadButton
            onClick={() => {
              dispatch(openDownloadModal());
              dispatch(getDownloadPackdetails(record.packId));
            }}
          />
        ) : (
          <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
        ))}

      {(record.status === "UPLOADED" || record.status === "TRANSCRIBING" || record.status === "PENDING" || record.status === "AV_IN_PROGRESS") && (
        <>
          <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
          <EditButton disabled={true} />
          <InfoButton disabled={true} />
          <DeleteButton disabled={true} />
        </>
      )}

      {record.status === "QC_READY" && (
        <>
          <PlayButtton
            disabled={false}
            record={record}
          />

          <InfoButton disabled={true} />

          {record.lockedUserEmail === "" ? (
            <DeleteButton disabled={true} />
          ) : (
            <LockButton
              disabled={false}
              record={record}
              onClick={() => {
                dispatch(setCurrentRecord(record));
                dispatch(openUnlockModal());
                // dispatch(fetchPackDetail(record.packId));
              }}
            />
          )}
        </>
      )}

      {record.status === "FAILED" && (
        <>
          <EditButton disabled={true} />
          <InfoButton disabled={true} />
          <DeleteButton
            disabled={false}
            onClick={() => {
              dispatch(setCurrentRecord(record));
              dispatch(openDeleteModal());
            }}
          />
        </>
      )}

      {record.status === "QC_IN_PROGRESS" && (
        <>
          <PlayButtton
            disabled={false}
            record={record}
          />
          <InfoButton
            disabled={false}
            onClick={() => {
              dispatch(fetchPackDetail(record.packId));
              dispatch(openDocumentInfoModal());

              dispatch(fetchPackDetail(record.packId));
            }}
          />

          {record.lockedUserEmail === "" ? (
            <DeleteButton disabled={true} />
          ) : (
            <LockButton
              disabled={false}
              record={record}
              onClick={() => {
                dispatch(setCurrentRecord(record));
                dispatch(openUnlockModal());
                // dispatch(fetchPackDetail(record.packId));
              }}
            />
          )}
        </>
      )}
    </div>
  );
}

export default InProgressActionColumn;
